import React from 'react';
import Tooltip from '../ui/utils/CustomTooltip/CustomTooltip';
import { useTranslation } from 'react-i18next';
import { ValidationStatus } from '../../store/form/types';
import { getValidationStatusName } from '../../helpers/translations';

interface Props {
  label: string;
  validationStatus: ValidationStatus;
}

const StatusLabel: React.FC<Props> = ({ label, validationStatus }) => {
  const { t, i18n } = useTranslation();
  return (
    <div className="inline-flex">
      <p className="font-semibold mr-2">{label}:</p>

      <div className="flex">
        <span className={`flex font-normal ${validationStatus === 'Pending' ? 'text-red-600' : 'text-green-600'}`}>
          {getValidationStatusName(validationStatus, t)}
        </span>

        {validationStatus === 'Pending' && (
          <Tooltip title={t('Compulsory questions to answer.')} placement="right">
            <span
              className="font-semibold px-1.5 rounded-full text-sm ml-1.5 text-white"
              style={{ backgroundColor: '#2563eb' }}
            >
              ?
            </span>
          </Tooltip>
        )}
      </div>
    </div>
  );
};

export default StatusLabel;
